import React from "react";
import { copyText } from "../../components/CustomComponent.js";

// กรอบหัวข้อของหน้า /document-api (การ์ด + h3 แรก ถูกแต่งเป็น hero ด้วย CSS .doc-scope)
export function DocSection({ title, eyebrow, children }) {
  return (
    <div className="body p-3 mt-3">
      <div className="rounded-3 bg-white p-3">
        <h3 className="fw-bold mb-3" data-eyebrow={eyebrow}>
          {title}
        </h3>
        <hr />
        {children}
      </div>
    </div>
  );
}

// กล่องโค้ดพร้อมปุ่ม copy ข้อความที่ copy คือข้อความเดียวกับที่แสดง
// inline = กล่องบรรทัดเดียว (เช่น URL) ไม่ใช้ <pre>
export function CodeBlock({ text, inline = false, className = "mb-3" }) {
  const value = text || "";
  return (
    <div
      className={`w-100 rounded-3 px-3 py-2 bg-light position-relative pe-5 ${className} ${inline ? "hpx-40 d-flex align-items-center" : ""}`}
      style={inline ? undefined : { minHeight: 100 }}
    >
      {inline ? <span>{value}</span> : <pre>{value}</pre>}
      <span
        className="position-absolute btn btn-light icon text-secondary pointer px-1 py-0 hpx-20 border-white"
        style={{ right: 8, top: inline ? 10 : 6, fontSize: 12 }}
        onClick={() => copyText(value)}
      >
        copy
      </span>
    </div>
  );
}
